import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { PageSpinner } from '@/components/ui/Feedback'
import { useAuthStore } from '@/store/auth'

/** Blocks unauthenticated access and remembers where the user was headed. */
export function RequireAuth() {
  const { status, tokens, hydrate } = useAuthStore()
  const location = useLocation()

  useEffect(() => {
    if (status === 'idle') void hydrate()
  }, [status, hydrate])

  if (status === 'idle' || status === 'authenticating') {
    return <PageSpinner label="Checking your session" />
  }
  if (status === 'anonymous' || !tokens) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return <Outlet />
}

/**
 * Keeps the two halves of the app apart: an unfinished setup cannot reach the
 * dashboard, and a finished one is not sent back through the wizard.
 */
export function RequireOnboarding({ expect }: { expect: 'complete' | 'incomplete' }) {
  const onboarding = useAuthStore((state) => state.onboarding)

  if (!onboarding) return <Outlet />

  if (expect === 'complete' && !onboarding.isComplete) {
    return <Navigate to="/onboarding" replace />
  }
  if (expect === 'incomplete' && onboarding.isComplete) {
    return <Navigate to="/dashboard" replace />
  }
  return <Outlet />
}
